import toolsClient from "@/api/toolsClient"
import { MULTIPART_HEADERS } from "@/api/apiUtils"

export const getAiPodcast = async (podcastKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}`)
  return response.data
}

export const updateAiPodcast = async (podcastKey, podcast, logo = null) => {
  const formData = new FormData()
  formData.append("podcast", JSON.stringify(podcast))
  if (logo) formData.append("logo", logo)
  const response = await toolsClient.put(`/podcast-bot/podcasts/${podcastKey}`, formData, MULTIPART_HEADERS)
  return response.data
}

export const deleteAiPodcast = async (podcastKey) => {
  await toolsClient.delete(`/podcast-bot/podcasts/${podcastKey}`)
}

export const getPodcastRecordingConfig = async (podcastKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/recordingConfig`)
  return response.data
}

export const updatePodcastRecordingConfig = async (podcastKey, config, fileCutIntro = null, fileCutOutro = null) => {
  const formData = new FormData()
  formData.append("recording_config", JSON.stringify(config))
  if (fileCutIntro) formData.append("file_cut_intro", fileCutIntro)
  if (fileCutOutro) formData.append("file_cut_outro", fileCutOutro)
  const response = await toolsClient.put(
    `/podcast-bot/podcasts/${podcastKey}/recordingConfig`,
    formData,
    MULTIPART_HEADERS
  )
  return response.data
}


export const getPodcastProcessingPresets = async (podcastKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/processingPresets`)
  return response.data
}

export const updatePodcastProcessingPresets = async (podcastKey, presets, fileAddIntro = null, fileAddOutro = null) => {
  const formData = new FormData()
  formData.append("processing_presets", JSON.stringify(presets))
  if (fileAddIntro) formData.append("file_add_intro", fileAddIntro)
  if (fileAddOutro) formData.append("file_add_outro", fileAddOutro)
  const response = await toolsClient.put(
    `/podcast-bot/podcasts/${podcastKey}/processingPresets`,
    formData,
    MULTIPART_HEADERS
  )
  return response.data
}

export const getPodcastInterviewExtractionPresets = async (podcastKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/interviewPresets`)
  return response.data
}

export const updatePodcastInterviewExtractionPresets = async (podcastKey, presets) => {
  const response = await toolsClient.put(`/podcast-bot/podcasts/${podcastKey}/interviewPresets`, presets)
  return response.data
}

export const getPodcastAiAdsPresets = async (podcastKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/aiAdsPresets`)
  return response.data
}

export const updatePodcastAiAdsPresets = async (podcastKey, presets) => {
  const response = await toolsClient.put(`/podcast-bot/podcasts/${podcastKey}/aiAdsPresets`, presets)
  return response.data
}

export const createRecordingPodcast = async ({
  accountKey,
  podcastPayload,
  logo,
  fileCutIntro = null,
  fileCutOutro = null,
  fileAddIntro = null,
  fileAddOutro = null,
}) => {
  const formData = new FormData()
  formData.append("podcast", JSON.stringify(podcastPayload))
  formData.append("logo", logo)
  if (fileCutIntro) formData.append("file_cut_intro", fileCutIntro)
  if (fileCutOutro) formData.append("file_cut_outro", fileCutOutro)
  if (fileAddIntro) formData.append("file_add_intro", fileAddIntro)
  if (fileAddOutro) formData.append("file_add_outro", fileAddOutro)
  const response = await toolsClient.post(
    `/podcast-bot/podcasts/recording/create?accountKey=${accountKey}`,
    formData,
    MULTIPART_HEADERS
  )
  return response.data
}
